import ActionDialog from "@dashboard/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@dashboard/components/ConfirmButton";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface ParentAttributeBulkDeleteDialogProps {
  confirmButtonState: ConfirmButtonTransitionState;
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  quantity: number;
}

const ParentAttributeBulkDeleteDialog = ({
  confirmButtonState,
  onClose,
  onConfirm,
  open,
  quantity,
}: ParentAttributeBulkDeleteDialogProps) => {
  const intl = useIntl();

  return (
    <ActionDialog
      confirmButtonState={confirmButtonState}
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={intl.formatMessage({
        id: "parentAttrBulkDeleteTitle",
        defaultMessage: "Delete Parent Attributes",
        description: "dialog title",
      })}
      variant="delete"
    >
      <FormattedMessage
        id="parentAttrBulkDeleteDescription"
        defaultMessage="{counter,plural,one{Are you sure you want to delete this parent attribute?} other{Are you sure you want to delete {displayQuantity} parent attributes?}}"
        values={{
          counter: quantity,
          displayQuantity: <strong>{quantity}</strong>,
        }}
      />
    </ActionDialog>
  );
};

ParentAttributeBulkDeleteDialog.displayName = "ParentAttributeBulkDeleteDialog";
export default ParentAttributeBulkDeleteDialog;